module.exports = __webpack_public_path__ + "2e49dc13a5aef69252afd35e56e3e4c2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/tiger-suit.png
// module id = 2024
// module chunks = 0